<template>    
    <v-dialog v-model="dialog" :width="$store.state.textFormatting.dialog.width">
        <template #activator="{ on: dialog }">
            <v-tooltip bottom eager>
                <template #activator="{ on: tooltip }">
                    <v-icon large v-on="{ ...tooltip, ...dialog }">info</v-icon>             
                </template>
                <span :style="$store.state.textFormatting.main"> Click for info. </span>
            </v-tooltip>
        </template>
        <v-card>
            <v-card-title class="headline grey lighten-2" primary-title :style="$store.state.textFormatting.headers" style="color:black">
                <slot></slot>
            </v-card-title>
            <v-card-text :style="$store.state.textFormatting.main">
                <slot name="body"></slot> 
            </v-card-text>           
            <v-divider></v-divider>
            <v-card-actions :style="$store.state.textFormatting.main">
                <slot name="action" :style="$store.state.textFormatting.main"></slot>
                <v-spacer></v-spacer>
                <v-btn color="red" flat @click="dialog = false" :style="$store.state.textFormatting.main">
                    Close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data () {
        return {
            dialog: false
        }
    }
}
</script>

                                            